import { useRef, useState } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { ArrowRight, HelpCircle, Plus } from 'lucide-react';

const faqEntries = [
  {
    title: 'Czym to się różni od zwykłej agencji marketingowej?',
    answer: 'Agencja marketingowa sprzedaje czas na ekran. DAIEN sprzedaje systemy które działają 24/7 bez Twojej ingerencji. Buduję dokładnie to, czego sam używam w swojej firmie - lead gen, voice agents, inteligentne bazy wiedzy (RAG), automatyzacja n8n. Nie sprzedaję usług "consulting AI" w powietrze - sprzedaję działające systemy z konkretną metryką.',
    tag: 'Pozycjonowanie',
    image: 'https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=2070&auto=format&fit=crop'
  },
  {
    title: 'Ile kosztuje wdrożenie AI Voice Agenta?',
    answer: 'Voicebot speed-to-lead wchodzi w pakiet Wzrost: 7 000 zł / miesiąc, bez osobnej opłaty wdrożeniowej. W tej kwocie masz pełną obsługę: odbieranie i oddzwanianie 24/7, integrację z kalendarzem, utrzymanie i optymalizację. Budżet na same reklamy płatny osobno, po Twojej stronie. Pełną wycenę pod Twój wolumen połączeń dostajesz po quizie kwalifikacyjnym i rozmowie diagnostycznej.',
    tag: 'Cennik',
    image: 'https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?q=80&w=2055&auto=format&fit=crop'
  },
  {
    title: 'Jak długo trwa wdrożenie systemu AI?',
    answer: [
      'Standard: 2-4 tygodnie od decyzji do produkcji, zależnie od zakresu:',
      'Lead gen + landing page: 2 tygodnie',
      'Voice agent z bazą wiedzy: 3 tygodnie',
      'Inteligentna baza wiedzy (RAG) z integracją Allegro / BaseLinker / Zendesk: 4 tygodnie',
      'Customowe systemy AIOS: 6-8 tygodni',
    ],
    tag: 'Process',
    image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?q=80&w=2000&auto=format&fit=crop'
  },
  {
    title: 'Z jakimi narzędziami pracujesz?',
    answer: 'n8n, Trigger.dev, Retell.ai, ElevenLabs, OpenAI GPT-4/5, Anthropic Claude Opus/Sonnet, pgvector + Postgres (Neon/Supabase), Pipedrive, Notion, Discord, Vercel. Stack open-source-first żeby kod i dane zostały u Ciebie - bez vendor lock-in na agencyjne SaaS-y.',
    tag: 'Stack',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2070&auto=format&fit=crop'
  },
  {
    title: 'Czy budżet na reklamy jest wliczony w cenę pakietu?',
    answer: 'Nie. Abonament pokrywa budowę, prowadzenie i optymalizację systemu. Budżet na reklamy płatny jest osobno, bezpośrednio do Meta czy Google, i zostaje w 100% po Twojej stronie. Na pakietach miesięcznych nie ma też opłaty wdrożeniowej, więc dokładnie widzisz, ile idzie na narzędzia, a ile na sam ruch.',
    tag: 'Budżet',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=2070&auto=format&fit=crop'
  },
  {
    title: 'Czy zobaczę realny zwrot i jak mierzysz wyniki?',
    answer: 'Tak, na konkretnych liczbach. Dostajesz dashboard ze statystykami sprzedaży w czasie rzeczywistym: koszt leada, koszt umówionego spotkania i ROI. Nie chowam się za "świadomością marki". Kontakt z leadem w mniej niż minutę potrafi dać nawet 3x wyższą konwersję, i to widać w danych.',
    tag: 'Wyniki',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=2070&auto=format&fit=crop'
  },
  {
    title: 'Czy moje dane i dane moich klientów są bezpieczne?',
    answer: 'Tak. Dane leżą na Twoich kontach i bazach, hostowane w UE i zgodnie z RODO. Nie sprzedaję ich ani nie udostępniam nikomu, a dostęp jest ograniczony do tego, co naprawdę konieczne. Cały system należy do Twojej firmy, więc nie jesteś uzależniony od żadnej agencji: jeśli kiedyś zakończymy współpracę, dane i konfiguracja zostają u Ciebie.',
    tag: 'Bezpieczeństwo',
    image: 'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=2070&auto=format&fit=crop'
  },
  {
    title: 'Co się dzieje po wdrożeniu? Zostawiasz mnie samego?',
    answer: 'Nie, to nie jest projekt "wdrożę i znikam". Buduję długoterminowe współprace: utrzymuję infrastrukturę, optymalizuję kampanie i rozwijam system razem z Twoją firmą. Na pakietach miesięcznych masz pełne wsparcie po stronie DAIEN, a na większych wdrożeniach dedykowane wsparcie z priorytetem.',
    tag: 'Wsparcie',
    image: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=2070&auto=format&fit=crop'
  },
  {
    title: 'Czy mogę zacząć od jednego modułu, a nie całego systemu?',
    answer: 'Tak, i tak najczęściej zaczynamy. Wchodzisz pakietem Start (strona, chatbot, kwalifikacja, reklamy) albo jednym modułem, na przykład samym voicebotem speed-to-lead. Kiedy zobaczysz wyniki, dokładamy kolejne elementy aż do pełnego systemu. Nie rzucam Cię od razu na custom wdrożenie za 25 tys.',
    tag: 'Start',
    image: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?q=80&w=2070&auto=format&fit=crop'
  }
];

export default function Journal() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const [expandedIdx, setExpandedIdx] = useState<number | null>(null);

  return (
    <section className="bg-bg py-16 md:py-24" ref={ref} id="faq" aria-label="Najczęstsze pytania">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10 lg:px-16">

        {/* Header */}
        <motion.div
          className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <div>
            <div className="flex items-center gap-4 mb-6">
              <div className="w-8 h-px bg-stroke"></div>
              <span className="text-xs text-muted uppercase tracking-[0.3em]">FAQ</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl tracking-tight font-light text-text-primary mb-4">
              Najczęstsze <span className="font-display italic">pytania</span>
            </h2>
            <p className="text-muted max-w-sm">Kliknij żeby rozwinąć. Brakuje Twojego pytania? Napisz przez formularz.</p>
          </div>

          <a
            href="#kontakt"
            className="hidden md:inline-flex border-gradient items-center gap-2 bg-surface text-text-primary rounded-full px-6 py-3 hover:bg-bg transition-colors group"
          >
            <span className="relative z-10 font-medium text-sm">Zadaj pytanie</span>
            <ArrowRight className="relative z-10 w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </a>
        </motion.div>

        {/* FAQ Accordion */}
        <div className="flex flex-col gap-4">
          {faqEntries.map((entry, idx) => {
            const isOpen = expandedIdx === idx;
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
                transition={{ duration: 0.6, delay: 0.1 * idx, ease: "easeOut" }}
                className="bg-surface/30 border border-stroke rounded-[40px] sm:rounded-3xl overflow-hidden hover:bg-surface transition-colors"
              >
                <button
                  type="button"
                  onClick={() => setExpandedIdx(isOpen ? null : idx)}
                  aria-expanded={isOpen}
                  className="w-full flex flex-col sm:flex-row items-start sm:items-center gap-6 p-4 text-left group"
                >
                  {/* Image Pill */}
                  <div className="w-full sm:w-32 h-48 sm:h-20 rounded-3xl sm:rounded-full overflow-hidden shrink-0">
                    <img
                      src={entry.image}
                      alt=""
                      loading="lazy"
                      className="w-full h-full object-cover grayscale opacity-80 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-500 group-hover:scale-105"
                      aria-hidden="true"
                    />
                  </div>

                  {/* Content */}
                  <div className="flex-1 px-2 sm:px-4 py-2 flex flex-col justify-center">
                    <h3 className="text-xl md:text-2xl font-light text-text-primary mb-2 transition-colors duration-300">
                      {entry.title}
                    </h3>
                    <div className="flex items-center gap-4 text-xs text-muted">
                      <span className="flex items-center gap-1">
                        <HelpCircle className="w-3 h-3" />
                        {entry.tag}
                      </span>
                    </div>
                  </div>

                  {/* Plus icon (rotates to X when open) */}
                  <div
                    className={`hidden sm:flex items-center justify-center w-14 h-14 rounded-full border border-stroke text-muted shrink-0 mr-2 transition-all duration-300 ${
                      isOpen
                        ? 'bg-text-primary text-bg border-transparent rotate-45'
                        : 'group-hover:bg-text-primary group-hover:text-bg group-hover:border-transparent'
                    }`}
                  >
                    <Plus className="w-5 h-5" />
                  </div>
                </button>

                {/* Expanded answer */}
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.4, ease: "easeOut" }}
                      className="overflow-hidden"
                    >
                      <div className="px-6 sm:px-10 pb-8 sm:pb-10 pt-2">
                        <div className="sm:ml-32 sm:pl-6 border-l border-stroke/50 sm:border-l-2">
                          {Array.isArray(entry.answer) ? (
                            <div className="pl-4 sm:pl-6 space-y-3">
                              <p className="text-base md:text-lg text-text-primary/80 leading-relaxed">
                                {entry.answer[0]}
                              </p>
                              <ul className="space-y-2">
                                {entry.answer.slice(1).map((line, i) => (
                                  <li key={i} className="flex items-start gap-3 text-base md:text-lg text-text-primary/80 leading-relaxed">
                                    <span className="mt-2.5 w-1.5 h-1.5 rounded-full bg-accent-to shrink-0" aria-hidden="true"></span>
                                    <span>{line}</span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          ) : (
                            <p className="text-base md:text-lg text-text-primary/80 leading-relaxed pl-4 sm:pl-6">
                              {entry.answer}
                            </p>
                          )}
                        </div>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </div>

        <a
          href="#kontakt"
          className="mt-10 w-full md:hidden border-gradient inline-flex items-center justify-center gap-2 bg-surface text-text-primary rounded-full px-6 py-4 hover:bg-bg transition-colors group"
        >
          <span className="relative z-10 font-medium">Zadaj pytanie</span>
          <ArrowRight className="relative z-10 w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </a>
      </div>
    </section>
  );
}
